'use strict';

angular.module('app.addNewMention', [])
    .controller('addNewMentionCtrl', ['$scope', '$rootScope', '$modal', 'addNewMentionService', '$http', '$modalInstance', 'mentionManagementService', 'newMentionsService',
        function ($scope, $rootScope, $modal, addNewMentionService, $http, $modalInstance, mentionManagementService, newMentionsService) {
            $scope.modalInstance = $modalInstance;
            mentionManagementService.getLanguagesOfInterestingCountries(false)
                .then(function(response) {
                    $scope.languages = response.data;
                }, function(errResponse) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = errResponse.message;
                })

            var url_getKeywordType = $rootScope.apiUrl + 'mention/getKeywordType';
            $http.get(url_getKeywordType, {loader: false})
                .success(function(responseGetNewMentionKeywordType){
                    $scope.keywordTypes = responseGetNewMentionKeywordType.data;
                    $scope.keywordTypes.forEach(function (val) {
                        if(val.name == "Url"){
                            val.name = "URL";
                        }
                        if(val.name == "Hash"){
                            val.name = "Hashtag";
                        }
                    })
                })   

            $scope.disableLanguages = false;
            $scope.$watch('keywordTypesOutput', function(newValue, oldValue){
                if(newValue != oldValue && newValue != undefined && newValue.length > 0) {
                    if(newValue[0].id == 1) {
                        $scope.disableLanguages = false;
                        angular.forEach($scope.languages, function(item) {
                            item.ticked = false;
                        });
                    } else {
                        $scope.disableLanguages = true;
                        angular.forEach($scope.languages, function(item) {
                            if(item.id == 0) {
                                item.ticked = true;
                            } else {
                                item.ticked = false;
                            }
                        });
                    }
                }
            });

            $scope.allTopics = [];
            var topicObject = {
                id: 1,
                name: "No Topic"
            }
            $scope.allTopics.push(topicObject);
            var url_getAllTopic = $rootScope.apiUrl + 'mention/getAllTopic';
            $http.get(url_getAllTopic, {loader: false})
                .success(function(responseGetNewMentionAllTopic){
                    angular.forEach(responseGetNewMentionAllTopic.data, function(item) {
                        $scope.allTopics.push(item);
                    })
                }) 

            $scope.allVerticals = [];
            var verticalObject = {
                id: 1,
                name: "No Industry"
            }
            $scope.allVerticals.push(verticalObject);
            var url_getAllVertical = $rootScope.apiUrl + 'mention/getAllVertical';
            $http.get(url_getAllVertical, {loader: false})
                .success(function(responseGetNewMentionAllVertical){
                    angular.forEach(responseGetNewMentionAllVertical.data, function(item) {
                        $scope.allVerticals.push(item);
                    })
                })   

            $scope.cancelAddNewMention = function() {
                $modalInstance.close();
            }

            $scope.selectedTopicRow = null;
            $scope.checkedTopicRow = null;
            $scope.setClickedTopicRow = function(id){
                $scope.checkedTopicRow = id;
                if ($scope.selectedTopicRow == $scope.checkedTopicRow) {
                    $("[name='topic']").removeClass('selected');
                    $scope.checkedTopicRow = null;
                }
                $scope.selectedTopicRow = $scope.checkedTopicRow;
            }

            $scope.selectedVerticalRow = null;
            $scope.checkedVerticalRow = null;
            $scope.setClickedVerticalRow = function(id){
                $scope.checkedVerticalRow = id;
                if ($scope.selectedVerticalRow == $scope.checkedVerticalRow) {
                    $("[name='vertical']").removeClass('selected');
                    $scope.checkedVerticalRow = null;
                }
                $scope.selectedVerticalRow = $scope.checkedVerticalRow;
            }

            $scope.addNewMention = function(topic_id, vertical_id) {
                $scope.selectedLanguageId = [];
                $scope.languages.forEach(function (val) {
                    if (val.ticked === true)
                        $scope.selectedLanguageId.push(val.id)
                });

                $scope.selectedType = "";
                $scope.keywordTypes.forEach(function (val) {
                    if (val.ticked === true)
                        $scope.selectedType = val.id;
                })

                var data = {
                    keyword: $scope.keyword,
                    keywordType: $scope.selectedType,
                    topic_id: topic_id,
                    vertical_id: vertical_id,
                    languages: $scope.selectedLanguageId
                }

                $scope.checkKeyword = encodeURIComponent($scope.keyword);
                newMentionsService.checkNewMention($scope.checkKeyword, $scope.selectedLanguageId[0], "addNew", true)
                    .then(function(responseCheckNewMention) {
                        addNewMentionService.addNewMention(data, true)
                            .then(function(responseAddNewMention) {
                                $modalInstance.close(function () {
                                    $log.info('Close Modal now');
                                })

                                $scope.firstLoad = true;
                                $scope.loadData();
                            }, function(responseAddNewMention) {
                                var errorModalInstance = $modal.open({
                                    scope: $scope,
                                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                    windowClass: 'modal-dialog-mention-error'
                                });
                                $scope.errorModalInstance = errorModalInstance;
                                $scope.errorMessage = responseAddNewMention.message;
                            })
                    }, function(responseCheckNewMention) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = responseCheckNewMention.message;
                    })
            }
        }  
])